export const engagementScaleMethods = {
    methods: {
        getEngagementScale(questions) {
            if (questions) {
                let engagementSubscale = {
                    vigorPoints: 0,
                    vigorPercentage: 0,
                    dedicationPoints: 0,
                    dedicationPercentage: 0,
                    absorptionPoints: 0,
                    absorptionPercentage: 0,
                }

                for (let i = 0; i < questions.answers.length; i++) {
                    if (questions.answers[i].tag == 'vigor') {
                        engagementSubscale.vigorPoints = (engagementSubscale.vigorPoints + questions.answers[i].value)
                    } else if (questions.answers[i].tag == "dedication") {
                        engagementSubscale.dedicationPoints = (engagementSubscale.dedicationPoints + questions.answers[i].value)
                    } else if (questions.answers[i].tag == "absorption") {
                        engagementSubscale.absorptionPoints = (engagementSubscale.absorptionPoints + questions.answers[i].value)
                    }
                }




                let engagementScaleAverage = this.calculateEngagementScaleScore(engagementSubscale)

                let engagementScale = {
                    engagementSubscale,
                    engagementScaleAverage
                }
                return engagementScale;

            } else {
                return null;
            }


        },
        calculateEngagementScaleScore(engagementSubscale) {
            engagementSubscale.vigorPercentage = Math.round((engagementSubscale.vigorPoints / 36) * 100)
            engagementSubscale.dedicationPercentage = Math.round((engagementSubscale.dedicationPoints / 30) * 100)
            engagementSubscale.absorptionPercentage = Math.round((engagementSubscale.absorptionPoints / 36) * 100)
            this.total = ((engagementSubscale.vigorPercentage + engagementSubscale.dedicationPercentage + engagementSubscale.absorptionPercentage) / 3)
            return Math.round(this.total)
        },
        getChartDataEngagamentScale(uwes){
            
            const chartData = {
                datasets: [
                  {
                    data: [
                     uwes.engagementScaleAverage,
                      100 - uwes.engagementScaleAverage,
                    ],
                    backgroundColor: [
                      this.adjustColor(uwes.engagementScaleAverage),
                    ],
                    borderWidth: 0,
                  },
                ],
                labels: ["Employee Engagement Index"],
              };

            return chartData;
        }
    }
};